/* eslint-disable max-len */
import { cn } from '../cn';

export const IconTwitter = ({ className = '' }): JSX.Element => (
  <svg role='img' className = {cn('inline', className)} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_44_516)'>
      <path d='M4 4L15.733 20H20L8.267 4H4Z' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M4 20L10.768 13.232M13.228 10.772L20 4' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
    </g>
    <defs>
      <clipPath id='clip0_44_516'>
        <rect width='24' height='24' fill='currentColor'/>
      </clipPath>
    </defs>
  </svg>
);
